import { ErrorService } from "services/error-service";
import { Router } from "aurelia-router";
import { Models } from "models/core";
import { NettingTypeService } from "services/netting-type-service";
import { autoinject } from "aurelia-framework";
import { ToastService } from "services/toast-service";
import { EventAggregator } from "aurelia-event-aggregator";

@autoinject
export class NettingTypeNew {
  private nettingtype: Models.NettingType = new Models.NettingType();

  constructor(
    private nettingTypeService: NettingTypeService, 
    private router: Router,
    private toastService: ToastService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator
  ) {}

  createNettingType() {
    this.nettingTypeService
      .post(this.nettingtype)
      .then(res => {
        this.eventAggregator.publish("nettingTypeListReset", 1);
        this.toastService.showSuccess("nettingtype.created");
        this.router.navigateToRoute("netting-type-list");
      })
      .catch(err => this.errorService.handleError(err));
  }
}
